import { render, staticRenderFns } from "./Bureau.vue?vue&type=template&id=368a3d8a&scoped=true&"
import script from "./Bureau.vue?vue&type=script&lang=js&"
export * from "./Bureau.vue?vue&type=script&lang=js&"
import style0 from "./Bureau.vue?vue&type=style&index=0&id=368a3d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a3d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VPagination,VTextField})
